import { validate, ValidationError } from 'class-validator';
import { Usuario } from './../entities/usuario.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { AltaUsuario } from '../entities/altausuario.entity';
import { RegisterUser } from '../entities/RegisterUser.entity';
import { Explotacion } from '../entities/explotacion.entity';
import { Respuesta } from '../entities/respuesta.entity';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';


declare var NotificationFx: any;
export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styles: [`
    .error { color: crimson; }
    .success { color: green; }
  ` ],
})

export class RegisterComponent implements OnInit {

  public nombreApellidos: string;
  public email: string;
  public dni: string;
  public poblacion: number;
  public contrato: number;
  public factura: string;
  public importe: string;
  public importeNumber: number;
  public telefono: string;
  public telefono2: string;
  public Efactura: boolean;
  public alerts: Array<string> = [];
  public resultado: Respuesta;
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public politicas: boolean;
  public explotaciones: Explotacion[];
  public usuario: RegisterUser = new RegisterUser();
  public usuarioAlta: AltaUsuario = new AltaUsuario();
  public usuarioNew: Usuario = new Usuario();
  public userExist: boolean;
  public formularioErroneo = false;
  public testMessages: Array<string> = [];

  public nombreApellidosInputError: Boolean;
  public emailInputError: Boolean;
  public dniInputError: Boolean;
  public poblacionInputError: Boolean;
  public contratoInputError: Boolean;
  public facturaInputError: Boolean;
  public importeInputError: Boolean;
  public telefono1InputError: Boolean;
  public telefono2InputError: Boolean;
  public politicasError: Boolean;
  public showSpinner = false;
  public selectedCar: string;
  public condicionesEnvio: string;
  public avisoEmail: string;
  public formModel: FormModel = {};
  public keyCapchasite: string;
  public captchaError: boolean;
  public telefonoexplotacion: string;
  public isEmmasa: boolean;
  public pie: string;
  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  public ngOnInit() {
    this.clearInputErrors();
    this.Efactura = true;
    this.userExist = false;
    this.poblacion = -1;
    this.sessionService.datosExplotacion = new Explotacion();
    this.condicionesEnvio = 'Seleccione población';
    this.sessionService.datosExplotacion.CondicionesEnvio = null;
    this.explotaciones = this.sessionService.Explotaciones;
    this.pie = environment.pie;
    if (this.explotaciones !== undefined && this.explotaciones.length === 1) {
      this.poblacion = 0;
      this.sessionService.datosExplotacion = this.explotaciones[0];
      this.cargarDatos();
    } else
      this.router.navigate(['/public/login']);
    this.keyCapchasite = environment.capchasiteKey;
  }

  public ActualizarUser(): void {
    if (document.getElementById('top') !== null)
      document.getElementById('top').scrollIntoView();
    this.usuario.AltaUsuario.ActualizarSiExiste = true;
    this.registerUser();
    this.userExist = false;
  }

  public registerUser(): void {
    if (this.poblacion !== -1) {
      this.usuarioAlta.CodExplotacion = this.explotaciones[this.poblacion].Codigo;
    }
    this.usuarioNew.Login = this.dni;
    this.usuarioNew.Nombre = this.nombreApellidos;
    this.usuarioAlta.Contrato = this.contrato;
    this.usuarioNew.EMail = this.email;
    this.usuarioNew.Telefono1 = this.telefono;
    this.usuarioNew.Telefono2 = this.telefono2;
    this.usuarioNew.EFactura = this.Efactura;
    this.usuario.AltaUsuario = this.usuarioAlta;
    this.usuario.Usuario = this.usuarioNew;
    this.usuario.gRecaptchaResponse = this.formModel.captcha;
    this.clearInputErrors();
    this.formularioErroneo = true;
    this.formModel.captcha = this.formModel.captcha === undefined ? null : this.formModel.captcha;
    if (this.isEmmasa) {
      this.usuario.AltaUsuario.ActualizarSiExiste = true;
      validate(this.usuario).then(resultado => {
        if (resultado.length > 0 || !this.politicas) {
          this.showErrors(resultado);
        } else {
          if (document.getElementById('top') !== null) {
            document.getElementById('top').scrollIntoView();
          }
          this.doRegisterUser();
        }
      });
    } else {
      this.usuarioAlta.SerieFranumFra = this.factura;
      this.usuarioAlta.ImporteUltimaFactura = this.importeNumber;

      if (!this.usuario.AltaUsuario.ActualizarSiExiste) {
        validate(this.usuario).then(resultado => {
          if (resultado.length > 0 || this.formModel.captcha === null ||
            this.politicas === false && isNaN(this.importeNumber)) {
            this.showErrors(resultado);
          } else {
            this.doRegisterUser();
          }
        });
      } else {
        validate(this.usuario).then(resultado => {
          if (resultado.length > 0 || this.politicas === false && isNaN(this.importeNumber)) {
            this.showErrors(resultado);
          } else {
            this.doRegisterUser();
          }
        });
      }
    }
  }

  private doRegisterUser() {
    this.userService.registerUser(this.explotaciones[this.poblacion].Codigo, this.usuario)
      .then(
        response => this.registerUserOnSuccess(response),
        response => this.registerUserOnError(response)
      );
  }

  private clearInputErrors() {
    this.nombreApellidosInputError = false;
    this.emailInputError = false;
    this.dniInputError = false;
    this.poblacionInputError = false;
    this.contratoInputError = false;
    this.facturaInputError = false;
    this.importeInputError = false;
    this.telefono1InputError = false;
    this.telefono2InputError = false;
    this.captchaError = false;
    this.politicasError = false;
  }

  private showErrors(resultado: ValidationError[]) {
    if (resultado.length > 0) {
      for (const errores of resultado) {
        for (const item of errores.children) {
          switch (item.property) {
            case 'Login':
              this.dniInputError = true;
              break;
            case 'Nombre':
              this.nombreApellidosInputError = true;
              break;
            case 'SerieFranumFra':
              this.facturaInputError = true;
              break;
            case 'EMail':
              this.emailInputError = true;
              break;
            case 'Telefono1':
              this.telefono1InputError = true;
              break;
            case 'Telefono2':
              this.telefono2InputError = true;
              break;
            case 'Contrato':
              this.contratoInputError = true;
              break;
            case 'CodExplotacion':
              this.poblacionInputError = true;
              break;
            case 'politicas':
              this.politicasError = true;
          }
        }
      }
    }
    if (this.formModel.captcha === null) {
      this.captchaError = true;
    }

    this.politicasError = !this.politicas;
    this.importeInputError = isNaN(this.importeNumber);
  }

  private registerUserOnSuccess(response): void {
    this.usuario.AltaUsuario.ActualizarSiExiste = false;
    this.messageCabecera = 'Usuario registrado correctamente';
    this.typeException = 2;
    this.messageComplet = 'Su solicitud de registro se ha realizado correctamente. En breve recibirá en su correo electrónico (' +
      this.usuario.Usuario.EMail + ') un correo de confirmación con su clave de acceso';
  }

  private registerUserOnError(response): void {
    this.formModel.captcha = null;
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      if (this.resultado.ErrNumber === 3502 && !this.usuario.AltaUsuario.ActualizarSiExiste) {
        this.userExist = true;
        this.messageCabecera = 'Usuario existe';
        this.messageComplet = this.resultado.Ex.Message;
        this.typeException = 4;
      } else {
        this.messageCabecera = 'Error en registro de usuario';
        this.messageComplet = this.resultado.Ex.Message;
        this.typeException = this.resultado.TipoExcepcion;
      }
    } else {
      this.messageCabecera = 'Error registro';
      this.messageComplet = 'Error al registrar el usuario, compruebe que sus datos son correctos';
      this.typeException = 1;
    }
  }

  private ValidarFormulario(): boolean {
    return this.formularioErroneo;
  }

  public cargarDatos() {
    if (this.poblacion !== -1) {
      const _explotacion = this.explotaciones[this.poblacion];
      this.sessionService.datosExplotacion = _explotacion;
      this.telefonoexplotacion = this.isNullOrEmpty(_explotacion.Contacto) ? ''
        : _explotacion.Contacto.substring(2, (_explotacion.Contacto.length - 1));
      this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la capeta de correo no deseado.' +
        'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
        _explotacion.Email + ' para asegurarse de que recibirá nuestros correos.';
      this.condicionesEnvio = _explotacion.CondicionesEnvio;
      this.isEmmasa = this.sessionService.datosExplotacion.Codigo === 'Emmasa';
    } else {
      this.sessionService.datosExplotacion = new Explotacion();
      this.sessionService.datosExplotacion.CondicionesEnvio = null;
      this.avisoEmail = null;
      this.condicionesEnvio = 'Seleccione población';
      this.isEmmasa = false;
    }
  }

  public cambiar() {
    if (this.importe.length > 0) {
      this.importe = parseFloat(this.importe.replace(',', '.')).toLocaleString('de-DE');
      this.importeNumber = parseFloat(this.importe.replace('.', '').replace(',', '.'));
    } else {
      this.importeNumber = undefined;
    }
  }

  parseStringToInt(val: string) {
    if (val) {
      return parseInt(val);
    }
    return '';
  }

  private isNullOrEmpty(text: string) {
    return text === null || text === undefined || text === '';
  }

  // MODAL

  _showModalPolitica = false;

  showModal() { return this._showModalPolitica; }

  closeModal() {
    this._showModalPolitica = false;
  }
}
